export default __webpack_public_path__ + "static/media/calculate-circumference-55.87073be1.svg";